import React, { useMemo, useState, useCallback } from 'react';
import { Alert, Button } from '@themesberg/react-bootstrap';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: 'gray',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

function Attachment({
  acceptedFiles = [],
  getRootProps,
  getInputProps,
  isDragActive,
  isDragAccept,
  isDragReject,
  onRemoveFile,
}) {
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const files = acceptedFiles.map((file, index) => (
    <div key={file.path || index} className="d-flex justify-content-between align-items-center p-2 border rounded mb-2">
      <div>
        <strong>{file.path || file.name}</strong>
        <div className="text-muted small">
          {(file.size / 1024).toFixed(1)} KB
        </div>
      </div>
      {onRemoveFile && (
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => onRemoveFile(index)}
        >
          Remove
        </Button>
      )}
    </div>
  ));

  return (
    <div className="mv-2">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the file here...</p>
        ) : (
          <p>Drag 'n' drop a file here, or click to select a file</p>
        )}
      </div>

      <Alert variant="info" className="mt-2 mb-2">
        <small>
          <strong>Accepted formats:</strong> PDF, JPEG, PNG<br />
          <strong>Maximum size:</strong> 25 MB
        </small>
      </Alert>

      {files.length > 0 && (
        <div className="mt-3">
          <h6>Uploaded Files:</h6>
          {files}
        </div>
      )}
    </div>
  );
}

export default Attachment;
